import React from 'react';
import PhoneVerificationContainer from '../../containers/PhoneVerificationContainer';
import ProgressBar2 from '../ProgressBar2';

const PhoneVerificationPage = () => {
  return (
    <section className="form-content-section-primary flow-text">
      <ProgressBar2 />
      <div className="container">
        <div className="row">
          <PhoneVerificationContainer />
        </div>
      </div>
    </section>
  );
};

export default PhoneVerificationPage;
